module.exports = __webpack_public_path__ + "files/1beb1217d7d29fc5646a1c3d4660d8c0.png";